module.exports = __webpack_public_path__ + "static/media/banesco-minus.29eb2b29.svg";